import React, { Suspense, useEffect, useState } from 'react';

import { createRoot } from 'react-dom/client';
import '../../assets/css/paymentPortPage.scss';
import _paymentPortApis from '../../apis/paymentPort.api';
import { GLOBAL } from '../../constants/global.const';
import _alertUtils, { SWAL } from '../../utils/alert.util';
import { Skeleton } from 'antd';

const InputSearch = React.lazy(() => import('./InputSearch'));
const ReceiptInfo = React.lazy(() => import('./ReceiptInfo'));
const PaymentErrorDesc = React.lazy(() => import('./ErrorDesc'));
const PaymentInfo = React.lazy(() => import('./PaymentInfo'));

const { STEP } = GLOBAL.PAYMENT_PORT;

const PaymentPortPage = ({ stepDefault, receiptCodeDefault }) => {
    const [step, setStep] = useState(stepDefault ? stepDefault : STEP.SEARCH);
    const [msgErr, setMsgErr] = useState('');
    const [receiptCode, setReceiptCode] = useState();
    const [receiptInfo, setReceiptInfo] = useState({});

    useEffect(() => {
        if (!receiptCodeDefault) return;
        setReceiptCode(receiptCodeDefault);
        setStep(STEP.RECEIPT_INFO);
    }, [receiptCodeDefault]);

    const redirectToErr = (msg) => {
        setStep(STEP.ERROR);
        setMsgErr(msg);
    };
    // Tìm kiếm thông tin phiếu thu
    const onSearch = async (dataPost) => {
        if (!dataPost.receiptCode) return;
        setReceiptCode(dataPost.receiptCode);
        setStep(STEP.RECEIPT_INFO);
    };

    // Lấy thông tin thanh toán
    const onGetInfoPayment = async () => {
        if (!receiptCode) {
            _alertUtils.show(SWAL.TYPE.WARNING, 'Không có thông tin phiếu thu');
            return;
        }
        setStep(STEP.PAYMENT_INFO);
    };

    const onReturn = () => {
        setStep(STEP.SEARCH);
    };

    const showReceiptInfo = (dataReceiptId) => {
        if (!dataReceiptId) return;
        setReceiptCode(dataReceiptId);
        setStep(STEP.RECEIPT_INFO);
    };

    const showHtml = () => {
        switch (step) {
            case STEP.ERROR: {
                return (
                    <PaymentErrorDesc message={msgErr} onReturn={onReturn} />
                );
            }
            case STEP.SEARCH: {
                return <InputSearch onSubmitForm={onSearch} />;
            }
            case STEP.RECEIPT_INFO: {
                return (
                    <ReceiptInfo
                        receiptCode={receiptCode}
                        showErr={redirectToErr}
                        onReturn={onReturn}
                        onGetInfoPayment={onGetInfoPayment}
                        sendReceiptInfo={(s) => setReceiptInfo(s)}
                        showReceiptInfo={showReceiptInfo}
                    />
                );
            }
            case STEP.PAYMENT_INFO: {
                return (
                    <PaymentInfo
                        receiptCode={receiptCode}
                        showErr={redirectToErr}
                        receiptInfo={receiptInfo}
                        onReturn={onReturn}
                    />
                );
            }
            default: {
                return null;
            }
        }
    };
    return (
        <>
            <Suspense
                fallback={<Skeleton.Input active={true} size={'large'} />}
            >
                {showHtml()}
            </Suspense>
        </>
    );
};

export default PaymentPortPage;

// Dùng để khai báo tag khi nhúng ngoài website
document.querySelectorAll('react-paymentport-page').forEach((domContainer) => {
    const root = createRoot(domContainer);
    const stepDefault = domContainer.dataset.stepDefault;
    const receiptCodeDefault = domContainer.dataset.receiptCodeDefault;
    root.render(
        <PaymentPortPage
            stepDefault={stepDefault}
            receiptCodeDefault={receiptCodeDefault}
        />
    );
});
